export default {
    root: {
        height: '100vh',
        overflow: 'auto',
    },
};
